<p>theme-option-elements-chart-gauge-shadow-opacity works!</p>
